import React from 'react';

import { Overlay } from 'office-ui-fabric-react/lib/Overlay';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import './style.css';

const Loading = ({
  label = '',
  isVisible = true,
  fullscreen = false,
  opacity = 1,
  position = null,
}) => {
  return (
    <div
      className={fullscreen ? 'loading is-fullscreen' : 'loading'}
      style={{ opacity: opacity }}
    >
      {isVisible && (
        <Overlay>
          <div className="loading-overlay">
            <Spinner
              label={label}
              size={SpinnerSize.medium}
              className="loading-spinner"
            />
          </div>
        </Overlay>
      )}
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/app/components/LoadingOverlay/index.jsx